import type { InternalAxiosRequestConfig } from 'axios';
import { instanceId } from 'service/metrics.service';
import { APP_TYPE, APP_VERSION } from 'utils/constants';

const getMetrics = () => {
  return {
    applicationType: APP_TYPE,
    applicationVersion: APP_VERSION,
    instanceId,
  };
};

export const addMetrics = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const { applicationType, applicationVersion, instanceId } = getMetrics();

  if (!config.headers) {
    config.headers = {} as typeof config.headers;
  }

  config.headers['X-App-Type'] = applicationType;
  config.headers['X-App-Version'] = applicationVersion;
  config.headers['X-App-Instance-Id'] = instanceId;

  return config;
};
